// extracted by mini-css-extract-plugin
export default {"loading":"style_loading__VUaQN","rotate":"style_rotate__OnSSi"};